module.exports = __webpack_public_path__ + "static/img/c4bd68bde6b8ee18603d88fa6b48eab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro2.png
// module id = Zblr
// module chunks = 1